import { SubsectionsButtonsOptions } from '@common/enums';
import { SectionTypes } from '@common/enums/section-type-enum';
import { ApplianceSectionType, RetailerFileSettings } from '@common/models';

export const cleanCompanyCode = (companyCode: string): string =>
    companyCode
        .replaceAll(' ', '-')
        .replace(/[^\w-]/g, '')
        .toLowerCase();

export const isOptionByApplianceSectionEnabled = (
    sectionType: ApplianceSectionType,
    option: SubsectionsButtonsOptions,
    retailerFileSettings?: RetailerFileSettings
): boolean => {
    return retailerFileSettings &&
        retailerFileSettings.subsectionOptions &&
        retailerFileSettings.subsectionOptions[sectionType]
        ? retailerFileSettings.subsectionOptions[sectionType][option]
        : false;
};

export const isCookingApplianceOptionEnabled = (
    retailerFileSettings: RetailerFileSettings | undefined,
    option: SubsectionsButtonsOptions
): boolean => isOptionByApplianceSectionEnabled(SectionTypes.cooking_appliance, option, retailerFileSettings);

export const isFaucetOptionEnabled = (
    retailerFileSettings: RetailerFileSettings | undefined,
    option: SubsectionsButtonsOptions
): boolean => isOptionByApplianceSectionEnabled(SectionTypes.faucet, option, retailerFileSettings);
